import { ChevronDownIcon } from '@chakra-ui/icons';
import { Button, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import React, { useMemo } from 'react';

interface YearPickerProps {
  selectedYear: number;
  handleSelectedYear: (year: number) => void;
  START_YEAR: number;
}

export const YearPicker = (props: YearPickerProps): JSX.Element => {
  const { START_YEAR, selectedYear, handleSelectedYear } = props;

  const SHOWED_YEARS = 3;
  const years = useMemo(() => {
    return Array.from({ length: SHOWED_YEARS }, (_, i) => i + START_YEAR);
  }, []);

  return (
    <Menu matchWidth={true}>
      <MenuButton
        variant={'outline'}
        as={Button}
        rightIcon={<ChevronDownIcon />}
        w={{base: 16, sm: 28}}
        fontWeight={'normal'}
        textAlign={'left'}>
        {selectedYear}
      </MenuButton>
      <MenuList zIndex={15}>
        {years.map(year => {
          return (
            <MenuItem key={year} onClick={() => handleSelectedYear(year)}>
              {year}
            </MenuItem>
          );
        })}
      </MenuList>
    </Menu>
  );
};
